import { render } from "./BSkeleton.vue?vue&type=template&id=ce8a1d68&scoped=true"
import script from "./BSkeleton.vue?vue&type=script&lang=js"
export * from "./BSkeleton.vue?vue&type=script&lang=js"

import "./BSkeleton.vue?vue&type=style&index=0&id=ce8a1d68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8a1d68"]])

export default __exports__